import { useSummonerProfileContext } from "@ugg/shared/components/SummonerProfiles/SummonerProfileContext";
import { NavTab, PageNav } from "@ugg/shared/components/common/PageNav";
import {
  getProfileOverviewUrl,
  getProfileChampionStatsUrl,
  getProfileLiveGameUrl,
  getProfilePlusTierListUrl,
} from "@ugg/shared/routes/app-routes";
import { useBoolLiveGameExist } from "@ugg/shared/api/requests/summoner-profiles/live-game";

export function SummonerProfilePageNav({ className }: { className?: string }) {
  const context = useSummonerProfileContext();
  const { riotUserName, riotTagLine, region } = context;
  const { data } = useBoolLiveGameExist(riotUserName, riotTagLine, region, { ssr: false, fetchPolicy: "network-only" });
  const navTabs: NavTab[] = [
    {
      to: getProfileOverviewUrl(region, riotUserName, riotTagLine),
      activePaths: [getProfileOverviewUrl(region, riotUserName, riotTagLine)],
      label: "Overview",
      reset: true,
    },
    {
      to: getProfileChampionStatsUrl(region, riotUserName, riotTagLine),
      label: "Champion Stats",
    },
    {
      to: getProfileLiveGameUrl(region, riotUserName, riotTagLine),
      label: "Live Game",
      live: !!data?.liveGameExists,
    },
    {
      to: getProfilePlusTierListUrl(region, riotUserName, riotTagLine),
      label: "PLUS Tier List",
      new: true,
    },
  ];

  return <PageNav className={className} tabs={navTabs} />;
}
